export default __webpack_public_path__ + "static/media/github.542ac437.svg";